import { useMemo } from "react";

import { UiCapabilityKey } from "@vega-api/extended/auth/useUiCapabilities";
import { TabNavigation } from "@vega-core/components/Layout/TabNavigation";
import { type Tab } from "@vega-core/models/core.type";
import { m } from "@vega-core/paraglide/messages";
import { SettingsSectionLayout } from "@vega-modules/scenes/Settings/components/SettingsSectionLayout";

import { useCapabilitiesGuard } from "../../../hooks/useCapabilitiesGuard";
import { useFeatureFlagGuard } from "../../../hooks/useFeatureFlagGuard";
import { GPSettingsFullPaths } from "../../../paths";
import { CASManagement } from "../components/CASManagement";
import { TemplateLibraryTab } from "../components/TemplateLibraryTab";

export const CASManagementPage = () => {
  useFeatureFlagGuard(
    "lp_reporting_v2",
    GPSettingsFullPaths.SettingsCollaborators,
  );
  useCapabilitiesGuard(
    UiCapabilityKey.CanManageFundCasConfigs,
    GPSettingsFullPaths.SettingsCollaborators,
  );
  const tabs: Tab[] = useMemo(
    () => [
      {
        index: "manage-cas",
        title: m.settings_casManagement_visibility(),
        component: <CASManagement />,
      },
      {
        index: "template-library",
        title: m.settings_casManagement_templates(),
        component: <TemplateLibraryTab />,
      },
    ],
    [],
  );

  return (
    <SettingsSectionLayout
      description={m.settings_casManagement_description()}
      title={m.settings_casManagement_title()}
    >
      <TabNavigation
        innerGap={false}
        noMargin
        noSingleTab={false}
        tabs={tabs}
        transparentBG
      />
    </SettingsSectionLayout>
  );
};
